import { set } from 'lodash';

const context = {
  state: {
    loading: false,
    redirectTo: null,
    snackbar: { show: false, button: { show: true, text: 'Fechar' } },
  },
  mutations: {
    SET_LOADING_DIALOG: (state, loading) => {
      set(state, 'loading', loading);
    },
    SET_REDIRECT_TO: (state, redirectTo) => {
      set(state, 'redirectTo', redirectTo);
    },
    TOGGLE_SNACKBAR: (state, payload) => {
      state.snackbar = { ...state.snackbar, ...payload };
    },
  },
  actions: {
    async setLoadingDialog({ commit }, loading) {
      commit('SET_LOADING_DIALOG', loading);
    },
    async setRedirectTo({ commit }, redirectTo) {
      commit('SET_REDIRECT_TO', redirectTo);
    },
    toggleSnackbar({ commit }, payload) {
      commit('TOGGLE_SNACKBAR', payload);
    },
  },
};
export default context;
